import { Navigate } from "react-router-dom";
import { useFirebase } from "../contexts/FirebaseContext";

const PublicRoute = ({ children }) => {
	const { user } = useFirebase();
	return user ? <Navigate to="/c/dashboard" /> : children;
};

export default PublicRoute;
